import { render, staticRenderFns } from "./RewardDetailsSection.vue?vue&type=template&id=37b257a8&scoped=true&"
import script from "./RewardDetailsSection.vue?vue&type=script&lang=js&"
export * from "./RewardDetailsSection.vue?vue&type=script&lang=js&"
import style0 from "./RewardDetailsSection.vue?vue&type=style&index=0&id=37b257a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b257a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37b257a8')) {
      api.createRecord('37b257a8', component.options)
    } else {
      api.reload('37b257a8', component.options)
    }
    module.hot.accept("./RewardDetailsSection.vue?vue&type=template&id=37b257a8&scoped=true&", function () {
      api.rerender('37b257a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Stamp/components/RewardDetailsSection.vue"
export default component.exports